import { useCallback, useMemo } from 'react';
export const useGetChildrenProps = ({ settings, onSettingsChange, onFileUpload }) => {
    const DEFAULT_CHILDREN_PROPS = useMemo(() => ({
        FinderPattern: {
            finderPattern: settings.finder_pattern,
            onFinderPatternChange: (finderStyle) => {
                onSettingsChange(Object.assign(Object.assign({}, settings), { finder_pattern: finderStyle }));
            },
        },
        CodePattern: {
            codePattern: settings.code_pattern,
            onCodePatternChange: (codePattern) => {
                onSettingsChange(Object.assign(Object.assign({}, settings), { code_pattern: codePattern }));
            },
        },
        Color: {
            codeColor: settings.code_color,
            backgroundColor: settings.background_color,
            finderPatternColor: settings.finder_pattern_color,
            onCodeColorChange: (codeColor) => {
                onSettingsChange(Object.assign(Object.assign({}, settings), { code_color: codeColor }));
            },
            onBackgroundColorChange: (backgroundColor) => {
                onSettingsChange(Object.assign(Object.assign({}, settings), { background_color: backgroundColor }));
            },
            onFinderPatternColorChange: (finderColor) => {
                onSettingsChange(Object.assign(Object.assign({}, settings), { finder_pattern_color: finderColor }));
            },
        },
        CenterLogo: {
            centerLogo: settings.center_logo_url,
            onCenterLogoChange: (centerLogo) => {
                onSettingsChange(Object.assign(Object.assign({}, settings), { center_logo_url: centerLogo }));
            },
            onFileUpload,
        },
        BackgroundImage: {
            backgroundImage: settings.background_image_url,
            onBackgroundImageChange: (backgroundImage) => {
                onSettingsChange(Object.assign(Object.assign({}, settings), { background_image_url: backgroundImage }));
            },
            onFileUpload,
        },
    }), [settings, onSettingsChange, onFileUpload]);
    const getChildrenProps = useCallback((child) => DEFAULT_CHILDREN_PROPS[child], [DEFAULT_CHILDREN_PROPS]);
    return getChildrenProps;
};
//# sourceMappingURL=useGetChildrenProps.js.map